// Imports
import React from 'react';
import styled from 'styled-components/macro';


// Styling
interface SmallProps {
	addSpace: boolean;
}

const Small = styled.small<SmallProps>`
	color: #707070;
	display: inline !important;
	margin-left: ${(props) => (props.addSpace ? '0.5rem' : '0')};
`;


// Define the accepted props
interface PropsBase {
	style?: {
		[index: string]: string | number;
	};
	prefix?: React.ReactElement;
	suffix?: React.ReactElement;
}

interface DateTimeProps extends PropsBase {
	ignoreUserTimezone?: true;
	dateTime: string | null;
	date?: never;
	breakBetween?: true;
	hideTime?: true;
}

interface DateProps extends PropsBase {
	date: string | null;
	dateTime?: never;
	breakBetween?: never;
	hideTime?: never;
}

type Props = DateProps | DateTimeProps;


// Function component
const Container: React.FC<Props> = (props) => {
	// Handle nulls
	if (!props.dateTime && !props.date) {
		return <td style={props.style}></td>;
	}
	
	
	// Standardize date / date time string
	let formatted: string;
	
	if (props.date) {
		formatted = props.date;
	} else {
		if (!props.dateTime) {
			throw new Error('A datetime should be provided here');
		}
		
		formatted = props.dateTime?.includes('T') ? props.dateTime : `${props.dateTime}-00:00`.replace(/\s/g, 'T');
	}
	
	
	// Return JSX
	return (
		<td style={props.style} data-testid='date-time-cell'>
			{props.prefix}
			
			{new Date(formatted).toLocaleDateString(undefined, {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				timeZone: props.date || ('ignoreUserTimezone' in props && props.ignoreUserTimezone) ? 'UTC' : undefined,
			})}
			
			{props.breakBetween && <br />}
			
			{props.hideTime !== true && !props.date && (
				<Small addSpace={!props.breakBetween}>
					{new Date(formatted).toLocaleTimeString(undefined, {
						hour: 'numeric',
						minute: '2-digit',
						timeZone: 'ignoreUserTimezone' in props && props.ignoreUserTimezone ? 'UTC' : undefined,
					})}
				</Small>
			)}
			
			{props.suffix}
		</td>
	);
};

const DateTimeCell = React.memo(Container);

export default DateTimeCell;
